import React from 'react';

const Logout = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 7.99998L4.44394 11.5551V8.88877H12.443V7.11119H4.44394V4.44482L0 7.99998Z"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M9.77734 3.05398e-05C8.72638 -0.00288353 7.68527 0.202773 6.71435 0.605085C5.74343 1.0074 4.86199 1.59837 4.12109 2.34377L5.37784 3.60051C6.55282 2.42553 8.11531 1.77761 9.77734 1.77761C11.4394 1.77761 13.0019 2.42553 14.1768 3.60051C15.3518 4.77549 15.9998 6.33798 15.9998 8.00002C15.9998 9.66205 15.3518 11.2245 14.1768 12.3995C13.0019 13.5745 11.4394 14.2224 9.77734 14.2224C8.11531 14.2224 6.55282 13.5745 5.37784 12.3995L4.12109 13.6563C5.63115 15.1672 7.63981 16 9.77734 16C11.9149 16 13.9235 15.1672 15.4336 13.6563C16.9445 12.1462 17.7773 10.1376 17.7773 8.00002C17.7773 5.86248 16.9445 3.85382 15.4336 2.34377C14.6927 1.59837 13.8113 1.0074 12.8403 0.605085C11.8694 0.202773 10.8283 -0.00288353 9.77734 3.05398e-05Z"
      fill="white"
      fillOpacity="0.5"
    />
  </svg>
);

export default Logout;
